import { useHead, useJsonld } from '#imports'
import { useGlobalStore } from '@/stores'

export default function useSeo() {
  const globalStore = useGlobalStore()
  globalStore.setBreadcrumbs([{ title: '生活有亮點計劃', isActive: true, url: '/membership' }])

  useSeoMeta({
    title: `生活有亮點計劃｜${import.meta.env.VITE_WEBSITE_TITLE}`,
    ogTitle: `生活有亮點計劃｜${import.meta.env.VITE_WEBSITE_TITLE}`,
    description: globalStore.seoDescriptions.membership,
    ogDescription: globalStore.seoDescriptions.membership
    // ogImage: faq.value.seo?.og_image?.link,
    // keywords: faq.value.seo?.meta_keywords.join(',')
  })

  useHead({
    link: [
      {
        rel: 'canonical',
        href: `${import.meta.env.VITE_DOMAIN}/membership`
      }
    ]
  })

  useJsonld({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首頁',
            item: import.meta.env.VITE_DOMAIN
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: '生活有亮點計劃',
            item: `${import.meta.env.VITE_DOMAIN}/membership`
          }
        ]
      }
    ]
  })
}
